import React, { useEffect, useState } from 'react';
import styles from '../styles/pdpl.module.scss';
import { collection, getDocs } from "firebase/firestore";
import {db} from '../config/firebase';

function PdplTr() {
    const [pdpl, setPdpl] = useState(null);

    useEffect(() => {
        fetchPost()
    }, [])

    const fetchPost = async () => {
       console.log('BURDA')
       const usersCollectionRef = collection(db, "Contracts");
        getDocs(usersCollectionRef)
            .then((querySnapshot)=>{               
                const newData = querySnapshot.docs.filter(x => x.id === 'Pdpl')
                if (newData.length > 0) {
                    setPdpl(newData[0].data())
                    console.log('AAA', newData[0].data())
                }
                //     .map((doc) => ({...doc.data(), id:doc.id }));              
                // console.log(newData);
            })
            .catch(e => console.error('HATA', e))
       
    }

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.header__content}>
                    <div>
                        <span className={styles.logo}>Ham Yap</span>
                    </div>
                </div>
            </div>

            <div className={styles.frame}>
                <div className={styles.container1}>
                    <div className={styles.container1__text1}>
                        <p>{pdpl != null && pdpl.content.substring(0, 27)}</p>
                    </div>
                    <div className={styles.container1__text1}>
                        <p>{pdpl != null && pdpl.content.substring(28, 44)}</p>
                    </div>
                </div>
               
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{pdpl != null && pdpl.content.substring(45, 631)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>{pdpl != null && pdpl.content.substring(632, 640)}</p>
                    </div>
                </div>
                    
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{pdpl != null && pdpl.content.substring(641, 696)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(696, 710)}</strong>{pdpl != null && pdpl.content.substring(710, 787)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(787, 816)}</strong>{pdpl != null && pdpl.content.substring(816, 1241)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(1241, 1254)}</strong>{pdpl != null && pdpl.content.substring(1254, 1292)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(1292, 1308)}</strong>{pdpl != null && pdpl.content.substring(1308, 1465)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(1465, 1489)}</strong>{pdpl != null && pdpl.content.substring(1489, 1870)}</p>
                        <p>{pdpl != null && pdpl.content.substring(1870, 1882)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>{pdpl != null && pdpl.content.substring(1882, 1894)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{pdpl != null && pdpl.content.substring(1894, 2147)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(2147, 2162)}
                        </p> 
                        <p> 
                            {pdpl != null && pdpl.content.substring(2162, 2362)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(2362, 2398)}
                        </p> 
                        <p> 
                            {pdpl != null && pdpl.content.substring(2398, 2533)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            {pdpl != null && pdpl.content.substring(2533, 2592)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(2592, 2648)}
                        </p> 

                            <li>
                                {pdpl != null && pdpl.content.substring(2651, 2782)}
                                <ul>
                                    <li>
                                        {pdpl != null && pdpl.content.substring(2785, 2879)}
                                        <ul>
                                            <li>
                                                {pdpl != null && pdpl.content.substring(2882, 3144)}
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>


                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(3145, 3210)}
                        </p> 
                        <ul>
                            <li>
                                {pdpl != null && pdpl.content.substring(3213, 3372)}
                            <ul>
                                <li>
                                    {pdpl != null && pdpl.content.substring(3375, 3421)}
                                    <ul>
                                        <li>
                                            {pdpl != null && pdpl.content.substring(3424, 3489)}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    {pdpl != null && pdpl.content.substring(3492, 3580)}
                                    <ul>
                                        <li>
                                            {pdpl != null && pdpl.content.substring(3583, 3767)}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            </li>
                        </ul>
                        <br/>
                        <p>{pdpl != null && pdpl.content.substring(3768, 3923)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(3924, 3957)}
                        </p> 
                        <p> 
                            <p>{pdpl != null && pdpl.content.substring(3958, 4115)}</p>
                        </p>
                        <br/>
                        <p> 
                            {pdpl != null && pdpl.content.substring(4115, 4407)}
                        </p>
                        <br/>
                        <p> 
                            {pdpl != null && pdpl.content.substring(4408, 4583)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            {pdpl != null && pdpl.content.substring(4584, 4623)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            <strong>{pdpl != null && pdpl.content.substring(4624, 4638)}</strong>{pdpl != null && pdpl.content.substring(4638, 4839)}
                        </p>
                        <br/>
                        <p>{pdpl != null && pdpl.content.substring(4840, 4883)}</p>
                        <p>{pdpl != null && pdpl.content.substring(4884, 4930)}</p>
                        <p>{pdpl != null && pdpl.content.substring(4931, 4995)}</p>
                        <p>{pdpl != null && pdpl.content.substring(4996, 5099)}</p>
                        <p>{pdpl != null && pdpl.content.substring(5100, 5189)}</p>
                        <p>{pdpl != null && pdpl.content.substring(5190, 5288)}</p>
                        <p>{pdpl != null && pdpl.content.substring(5289, 5412)}</p>
                        <p>{pdpl != null && pdpl.content.substring(5413, 5537)}</p>
                        <p>{pdpl != null && pdpl.content.substring(5538, 5683)}</p>
                        <p>{pdpl != null && pdpl.content.substring(5684, 5803)}</p>
                        <p>{pdpl != null && pdpl.content.substring(5804, 5872)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>{pdpl != null && pdpl.content.substring(5873, 5905)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{pdpl != null && pdpl.content.substring(5906, 5917)}</p>
                        <ul>
                            <li>
                                {pdpl != null && pdpl.content.substring(5919, 6012)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6015, 6147)}
                            </li>
                        </ul>
                        <br/>
                        <p>{pdpl != null && pdpl.content.substring(6147, 6160)}</p>
                        <ul>
                            <li>
                                {pdpl != null && pdpl.content.substring(6163, 6217)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6219, 6362)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6365, 6419)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6422, 6496)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6498, 6616)}
                            </li>
                        </ul>
                        <p>{pdpl != null && pdpl.content.substring(6617, 6976)}</p>
                        <br/>
                        <p>{pdpl != null && pdpl.content.substring(6977, 7154)}</p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text2}>
                        <p>{pdpl != null && pdpl.content.substring(7155, 7202)}</p>
                        <br/>
                    </div>
                </div>

            </div>
        </div>
      
    )
}

export default PdplTr;